import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('goods_received_notes_2'),
    updateStatus: defineMessage('update_status'),
    lastNote: defineMessage('last_note'),
    statusNotReceived: defineMessage('not_received'),
    statusPartiallyReceived: defineMessage('partially_received'),
    statusFullyReceived: defineMessage('fully_received'),
    fieldDate: defineMessage('date'),
    fieldAuthor: defineMessage('author'),
    fieldComment: defineMessage('comment'),
};
